import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Pathologist icon
 *
 * @category Medical
 */
const Pathologist = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M19.13 8.94c.92-.79-1.55-.72-1.75-1.07-.51-.4-.18-1.54-.53-2.22-.12-.26-.32-.5-.58-.63-.78-.33-1.37-.15-2.58-.2-1.38.08-3.21-.21-4.33.2-1.03.47-.54 1.96-1 2.75-.36.46-1.1.32-1.61.52-.63.2-.53.61.17.77.63.14 1.31.06 1.51.23.22.14.12.49.14 1.06v12.26c0 .6.14 1.22.4 1.81 1.51 3.57 7.24 2.98 7.95-.84.32-2.73.02-9.69.13-14.02.06-.66 1.47-.26 1.94-.55l.13-.06zm-8.46-3.29c1.06.07 3.31 0 4.3.04.68-.02.83.56.84 1.14 0 .48.05 1.17-.42 1.42-.39.18-1.29.08-2.3.11-1.14-.05-2.02.07-2.85-.11-.78-.17-.48-1.27-.45-2.13 0-.22.17-.53.87-.48zm5.31 17.56c-.37 2.38-3.78 3.53-5.57 1.6-1.1-1.1-.94-2.92-.89-4.51.02-1.01.97-.88 2.1-.97.31-.03.95-.21.92-.46-.13-.51-1.26-.48-1.76-.52-1.4.06-1.7-1.67-.38-1.94.34-.06.67-.06 1.02-.09.7 0 1.78-.52.59-.87-.85-.2-2.49.06-2.47-1.05-.12-1.3 1.56-.97 2.47-1.2 1.31-.43-.08-.94-1.02-.89-.81 0-1.34-.17-1.43-.82-.06-.63-.15-1.58.13-2.13.21-.32.77-.27 1.66-.28h3.58c.62.05.94-.09 1.11.27.02 1.64.09 11.12-.02 13.72l-.02.12zm9.26-2.31c-.58-1.12-1.61-2.95-2.28-4.18-.78-1.59-1.3-1.86-2.14-.21-.91 1.77-2.27 3.54-2.83 5.38-.69 2.5 1.4 5.11 4 4.92 2.83-.02 4.57-3.43 3.3-5.8zM21.7 26c-3.3-.39-3.42-4.13-1.69-6.61.5-.76.9-2.11 1.85-2.28 1 .31 1.41 1.77 1.94 2.64 1.53 2.45 1.17 5.93-1.91 6.25z"
        />
      </svg>
    );
  }
);

Pathologist.displayName = 'Pathologist';

export { Pathologist };
